import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Col, Card, CardHeader, CardBody } from 'reactstrap';

const MonthlyAttendanceChart = React.memo(
  ({ monthlyAttendance, currentYear, setCurrentYear }) => {
    const series = [
      {
        name: 'Present',
        data: Array.isArray(monthlyAttendance?.monthly)
          ? monthlyAttendance.monthly.map((month) => month.Present || 0)
          : [],
      },
      {
        name: 'Absent',
        data: Array.isArray(monthlyAttendance?.monthly)
          ? monthlyAttendance.monthly.map((month) => month.Absent || 0)
          : [],
      },
    ];
    const options = {
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },

      colors: ['#A6478E', '#fd625e'],
      xaxis: {
        categories: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
      },
      yaxis: {
        title: {
          text: 'Attendance',
        },
      },
      grid: {
        borderColor: '#f1f1f1',
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    return (
      <Col xl={8} lg={8} md={8} sm={12}>
        <Card className="card-h-100">
          <CardHeader className="d-flex justify-content-between align-items-center bg-white">
            <h6 className="card-title mt-2">Monthly Attendance Overview</h6>
            <span className="ms-auto text-muted">
              <select
                className="form-select adjust-month-overview-date-select"
                value={currentYear}
                onChange={(e) => setCurrentYear(parseInt(e.target.value))}
              >
                {[...Array(3)].map((_, index) => {
                  const year = new Date().getFullYear() - index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
            </span>
          </CardHeader>
          <CardBody className="mb-0 pb-0">
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={350}
              className="apex-charts"
            />
          </CardBody>
        </Card>
      </Col>
    );
  }
);

export default MonthlyAttendanceChart;
